import {JsonObject, JsonProperty} from "typescript-json-serializer";

@JsonObject()
export class SketchTooltipOptionsPropertiesConfiguration {
    /**
     * Whether tooltips are shown while sketching and editing.
     *
     * @default false
     *
     * [Read more...](https://developers.arcgis.com/javascript/latest/api-reference/esri-views-interactive-sketch-SketchTooltipOptions.html#enabled)
     */
    @JsonProperty()
    declare enabled?: boolean;

    constructor() {}
}